"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = ["M10.71 7.29l-4-4a1.003 1.003 0 00-1.42 1.42L8.59 8 5.3 11.29c-.19.18-.3.43-.3.71a1.003 1.003 0 001.71.71l4-4c.18-.18.29-.43.29-.71 0-.28-.11-.53-.29-.71z"];
//# sourceMappingURL=chevron-right.js.map